import React from 'react';

export function Controls({ soundEnabled, onToggleSound, onShowHint, showHint, hintEnabled, hintHighlight }) {
    return (
        <div className="controls">
            <button 
                className={`control-btn ${soundEnabled ? 'active' : ''}`}
                onClick={onToggleSound}
                title="Toggle Sound"
                style={{
                    backgroundImage: soundEnabled ? "url('./images/SVG/Sound.svg')" : "url('./images/SVG/mute.svg')",
                }}
            >
            </button>
            <button 
                className={`control-btn ${!hintEnabled ? 'disabled' : ''}`}
                onClick={onShowHint}
                title={hintEnabled ? "Get Hint" : "Make an incorrect match to unlock hint"}
                disabled={!hintEnabled}
                style={{
                    backgroundImage: (showHint || hintHighlight) ? "url('./images/SVG/hint-active.svg')" : "url('./images/SVG/hint.svg')",
                    opacity: hintEnabled ? 1 : 0.3,
                    cursor: hintEnabled ? 'pointer' : 'not-allowed'
                }}
            >
            </button>
        </div>
    );
}
